import { PLASTER, SEMI_SWEET, BAY_ISLE, TERRACOTTA, PROPER_GREY, RULE, WHITE, FONT_BODY } from "../theme";

export default function GlobalStyles() {
  const css = `
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html { scroll-behavior: smooth; }
    body {
      background: ${PLASTER}; font-family: ${FONT_BODY}; -webkit-font-smoothing: antialiased;
      color: ${SEMI_SWEET};
    }
    a { color: inherit; }
    input, textarea {
      width: 100%; padding: 11px 14px; border: 1px solid ${RULE};
      border-radius: 8px; font-family: ${FONT_BODY}; font-size: 13.5px;
      background: ${WHITE}; color: ${BAY_ISLE}; outline: none; transition: border-color 0.15s;
      -webkit-appearance: none;
    }
    textarea { resize: vertical; min-height: 100px; }
    input:focus, textarea:focus { border-color: ${TERRACOTTA}; box-shadow: 0 0 0 3px rgba(195,135,98,0.1); }
    input::placeholder, textarea::placeholder { color: ${PROPER_GREY}; }
    label {
      font-size: 11px; font-weight: 600; letter-spacing: 0.06em; color: ${SEMI_SWEET};
      display: block; margin-bottom: 6px; font-family: ${FONT_BODY};
    }
    .step-label {
      font-size: 9.5px; font-weight: 700; letter-spacing: 0.2em; text-transform: uppercase;
      color: ${PROPER_GREY}; margin-bottom: 12px; display: flex; align-items: center; gap: 8px;
      font-family: ${FONT_BODY};
    }
    .step-label::after { content: ''; flex: 1; height: 1px; background: ${RULE}; }
    button[type="submit"], .btn-primary {
      padding: 14px 24px; border: none; border-radius: 9px;
      font-family: ${FONT_BODY}; font-size: 11.5px; font-weight: 700;
      letter-spacing: 0.1em; text-transform: uppercase; cursor: pointer; transition: all 0.18s;
      background: ${BAY_ISLE}; color: ${WHITE};
    }
    button[type="submit"]:hover:not(:disabled), .btn-primary:hover { background: ${SEMI_SWEET}; }
    button:disabled { cursor: not-allowed; opacity: 0.6; }
  `;
  return <style>{css}</style>;
}
